export function parseImageDescriptionToHTML(description) {
  // console.log(description);
  const italicRegex = /_(.*?)_/ig;
  const boldRegex = /\*(.*?)\*/ig;
  const cutThroughRegex = /~(.*?)~/ig;
  let formated = `${description}`.split("\n").join("<br/>");
  const italicMatch = formated.match(italicRegex);
  const boldMatch = formated.match(boldRegex);
  const cutThroughMatch = formated.match(cutThroughRegex);
  if (Array.isArray(italicMatch) && italicMatch?.length > 0) {
    italicMatch.forEach(x => {
      const y = `<i>${x.replaceAll("_", "")}</i>`;
      formated = formated.replace(x, y);
    });
  }

  if (Array.isArray(boldMatch) && boldMatch?.length > 0) {
    boldMatch.forEach(x => {
      const y = `<b>${x.replaceAll("*", "")}</b>`;
      formated = formated.replaceAll(x, y);
    });
  }

  if (Array.isArray(cutThroughMatch) && cutThroughRegex?.length > 0) {
    boldMatch.forEach(x => {
      const y = `<s>${x.replaceAll("~", "")}</s>`;
      formated.replaceAll(x, y);
    });
  }
  // console.log(formated);
  return formated;
}